<template>
    <Modal :value="visible" :mask-closable="false">
        <div slot="close">
            <Icon type="ios-close" @click="$emit('cancel')" />
        </div>
        <div slot="header">
            <div style="line-height: 20px;">
                <div style="font-size: 20px;font-weight: 600;color: #000">批量导入修改</div>
                <div style="display: flex;justify-content: space-between;margin-top: 10px;flex-direction: column;">
                    <div style="color: #aaa;font-size: 14px;">请上传Excel(.xlsx/.csv)文件，系统将根据[书籍ID]匹配已有书籍，并批量更新对应字段。</div>
                    <div style="color: #aaa;font-size: 14px;">不可修改字段:书籍ID/内部书名/作者/版权方/章节数/字数</div>
                </div>
            </div>
        </div>
        <Upload type="drag" :before-upload="handleUpload" action="/">
            <div style="padding: 50px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>将文件拖拽到此处或点击选择文件</p>
                <p>(支持.xlsx/.csv)</p>
            </div>
        </Upload>
        <div v-if="file != null"
            style="display: flex;justify-content: space-between;color:#aaa;align-items: center;margin: 10px 0;font-size:15px;color:#666;border: 1px solid #aaa;padding:10px;border-radius: 12px;">
            <div>
                {{ file.name }}
            </div>
            <Icon type="md-close" :style="{ cursor: 'pointer' }" @click="file = null" />
        </div>
        <template #footer>
            <Button @click="$emit('cancel')">取消</Button>
            <Button type="primary" @click="handleSubmit" :loading="uploadLoading">确认导入</Button>
        </template>
    </Modal>
</template>

<script>
import { importNovelExcel } from '@/api/novel'
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            file: null,
            uploadLoading: false
        }
    },

    watch: {
        visible() {
            this.file = null
        }
    },
    methods: {
        handleUpload(e) {
            this.file = e
            return false;
        },
        handleSubmit() {
            if(!this.file)return
            const formData = new FormData()
            formData.append('file', this.file)
            this.uploadLoading = true
            importNovelExcel(formData).then(r => {
                this.$Message.success("解析完成")
                this.$emit('confirm', r.data)
            }).finally(() => {
                this.uploadLoading = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
.layout-card {
    /deep/ .ivu-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

}
</style>
